export class UrlHelper {

    constructor() {}

    sanitiseUrl(url: string): string {
        // workaround for issues in only some CS configurations whereby /index gets wrongly appended to Action.Url targets
        // because the routing has not correctly set Index as default action. Should be fixed properly at routing level in future.
        return url.includes("/index/") ? url.replace("/index/", "/") : url;
    }
}